import { useCallback } from "react"
import { PortalAccountDomain } from "../enums"

type IBOnboardingConfig = {
    domain: PortalAccountDomain
    flow: 'simplified' | 'standard'
    exclude: string[]
}

const commonExclude = ["AUS", "NZL", "CYP"]

const tmlcSimplified: IBOnboardingConfig = {
    domain: PortalAccountDomain.TMLC,
    flow: "simplified",
    exclude: commonExclude,
}

const tmlcSimplifiedAllCountries: IBOnboardingConfig = {
    domain: PortalAccountDomain.TMLC,
    flow: "simplified",
    exclude: [],
}

const tmsyStandard: IBOnboardingConfig = {
    domain: PortalAccountDomain.TMSY,
    flow: "standard",
    exclude: commonExclude,
}

const IB_ONBOARDING_ORG: Record<string, IBOnboardingConfig> = {
    "84805": tmlcSimplified,
    "63748": tmsyStandard,
    "290985": tmlcSimplified,
    "291213": tmlcSimplified,
    "291039": tmlcSimplified,
    "291311": tmlcSimplified,
    "291272": tmlcSimplified,
    "292362": tmlcSimplified,
    "292293": tmlcSimplified,
    "292106": tmlcSimplified,
    "292085": tmlcSimplified,
    "292084": tmlcSimplified,
    "292075": tmlcSimplified,
    "292073": tmlcSimplified,
    "292009": tmlcSimplified,
    "292934": tmlcSimplified,
    "138935": tmlcSimplified,
    "292922": tmlcSimplified,
    "292162": tmlcSimplified,
    "291085": tmlcSimplified,
    "293120": tmlcSimplifiedAllCountries,
    "293095": tmlcSimplifiedAllCountries,
    "293096": tmlcSimplifiedAllCountries,
    "293076": tmlcSimplifiedAllCountries,
    "293082": tmlcSimplifiedAllCountries,
}

const IB_COUNTRY_WHITELIST: Record<string, string[]> = {
    "43": ["AFG"]
}

export const getIBCountryWhitelist = (pid?: string): string[] =>
    (pid && IB_COUNTRY_WHITELIST[pid]) || []

export const useIBOnboarding = () => {
    const getIBInfo = useCallback((afsAid: string, countryCode3: string) => {
        if (!afsAid || !countryCode3) return undefined
        const ib = IB_ONBOARDING_ORG[afsAid]
        if (!ib || ib.exclude.includes(countryCode3)) return undefined
        return ib
    }, [])
    return { getIBInfo }
}
